import { Clear, Close, Done } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  Modal,
  Paper,
  SwipeableDrawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextareaAutosize,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { generalToastStyle } from "../../utils/toast.styles";
import "./product.styles.scss";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#a36e29",
    },
  },
  typography: {
    fontFamily: '"Work Sans", sans-serif',
  },
});

const ProductComponent = () => {
  const product = JSON.parse(localStorage.getItem("admin"));
  const [page, setPage] = useState(0);
  const [id, setId] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [products, setProducts] = useState(null); /// stores all the products
  const [showDrawer, setShowDrawer] = useState(false);
  const [message, setMessage] = useState();
  const [productClicked, setProductClicked] = useState(0);
  const [dialog, setDialog] = useState(false);
  const [variantDialog, setVariantDialog] = useState(false);
  const [openVariant, setOpenVariant] = useState();
  const [variantDeleteDialogOpen, setVariantDeleteDialogOpen] = useState(false);

  const [deleteRowId, setDeleteRowId] = useState();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const [searchResults, setSearchResults] = useState([]);

  const getProduct = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}v1.0.0/admin/product/all.php`, {
        headers: {
          Authorization: `Bearer ${product.token}`,
        },
      })
      .then((response) => {
        console.log(response.data.response);
        response.data.response.map((item, index) => {
          item.display_number = index;
          return item;
        });
        setProducts(response.data.response);
        setSearchResults(response.data.response);
      })
      .catch((error) => {
        toast.warn(error.response.data.message, generalToastStyle);
      });
  };

  const handleBlockProductDialog = () => {
    const requestData = {
      action: variantDialog ? "product-variant-block" : "product-block",
      id: id,
      reason: message,
    };
    axios
      .put(
        `${process.env.REACT_APP_API_URL}v1.0.0/admin/product/update.php`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${product.token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast(response.data.message, generalToastStyle);
        getProduct();
        setDialog(false);
        setVariantDialog(false);
      })
      .catch((error) => {
        toast.warn(error.response.data.message, generalToastStyle);
      });
  };

  const allowProduct = (productId, productDetails) => {
    if (!checkProductDetails(productDetails)) {
      toast.warn("Metal information is missing", generalToastStyle);
      return;
    }
    if (!checkProductInfographics(productDetails)) {
      toast.warn("Product must have 3 images and 1 video", generalToastStyle);
      return;
    }
    const requestData = {
      action: "product-allow",
      id: productId,
      product_details: productDetails,
    };

    axios
      .put(
        `${process.env.REACT_APP_API_URL}v1.0.0/admin/product/update.php`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${product.token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast(response.data.message, generalToastStyle);
        getProduct();
      })
      .catch((error) => {
        toast.warn(error.response.data.message, generalToastStyle);
      });
  };

  const allowProductVariant = (variantId, productDetails) => {
    // console.log("productDetails", productDetails)
    if (productDetails.name.length === 0) {
      toast.warn("Variant name is missing", generalToastStyle);
      return;
    }
    const requestData = {
      action: "product-variant-allow",
      id: variantId,
    };

    axios
      .put(
        `${process.env.REACT_APP_API_URL}v1.0.0/admin/product/update.php`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${product.token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast(response.data.message, generalToastStyle);
        getProduct();
      })
      .catch((error) => {
        toast.warn(error.response.data.message, generalToastStyle);
      });
  };

  const blockProduct = (productId, isVariant = false) => {
    setId(productId);
    setDialog(!isVariant);
    setVariantDialog(isVariant);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const rowClicked = (row) => {
    setProductClicked(products.indexOf(row));
    console.log(row);
    if (!checkProductDetails(row)) {
      toast.warn(`Metal information is missing`, generalToastStyle);
    }
    if (!checkProductInfographics(row)) {
      toast.warn("Product must have 3 images and 1 video", generalToastStyle);
    }
    setShowDrawer(true);
  };

  const checkProductInfographics = (row) => {
    if (!Array.isArray(row.images)) return false;
    // Check if the prodct have all the images and videos
    const images = row.images || [];
    // Error here Uncaught TypeError: t.filter is not a function
    const imgCount = images.filter((image) => image.type === "img").length;
    const vidCount = images.filter((image) => image.type === "vid").length;
    if (imgCount >= 3 && vidCount > 0) {
      return true;
    } else {
      return false;
    }
  };

  const checkProductDetails = (row) => {
    let allDataPresent = true;
    if (
      row.customizations.variants.options[0]?.metal_info &&
      row.customizations.variants.options[0]?.stone_info
    ) {
      const metalInfo = row.customizations.variants.options[0].metal_info;
      if (metalInfo) {
        const metalKeys = Object.keys(metalInfo);
        metalKeys.forEach((key) => {
          if (
            metalInfo[key] === null ||
            metalInfo[key] === undefined ||
            metalInfo[key] === ""
          ) {
            console.log(key, metalInfo[key]);
            allDataPresent = false;
          }
        });
        return allDataPresent;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const search = (query) => {
    if (query === "") {
      setSearchResults(products);
      return;
    }
    const results = products.filter(
      (product) =>
        product.tags.toLowerCase().includes(query.toLowerCase()) ||
        product.hash.toLowerCase().includes(query.toLowerCase()) ||
        product.customizations.variants.options[0].metal_info.gross_wt
          .toString()
          .toLowerCase()
          .includes(query.toLowerCase())
    );
    setPage(0);
    setSearchResults(results);
  };

  useEffect(() => {
    getProduct();
  }, []);

  return (
    <div className="product-component">
      <ToastContainer />

      {/* Disable Product Dialog */}
      <Modal open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "10px",
            width: 400,
            backgroundColor: "white",
            p: 4,
          }}
        >
          <Typography
            style={{
              fontWeight: 700,
              marginBottom: "20px",
              fontFamily: '"Open Sans", sans-serif',
              fontSize: "1.2rem",
              textAlign: "center",
            }}
          >
            Are you sure you want to block this product?
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "30px",
            }}
          >
            <Button
              variant="outlined"
              style={{
                width: "48%",
                fontWeight: "bold",
                border: "2px solid #a36e29",
                color: "#a36e29",
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "0.8rem",
              }}
              onClick={() => setDeleteDialogOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{
                width: "48%",
                fontWeight: "bold",
                background: "#a36e29",
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "0.8rem",
              }}
              onClick={() => {
                blockProduct(deleteRowId, false);
                setDeleteDialogOpen(false);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={variantDeleteDialogOpen} onClose={() => setVariantDeleteDialogOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "10px",
            width: 400,
            backgroundColor: "white",
            p: 4,
          }}
        >
          <Typography
            style={{
              fontWeight: 700,
              marginBottom: "20px",
              fontFamily: '"Open Sans", sans-serif',
              fontSize: "1.2rem",
              textAlign: "center",
            }}
          >
            Are you sure you want to block this variant?
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "30px",
            }}
          >
            <Button
              variant="outlined"
              style={{
                width: "48%",
                fontWeight: "bold",
                border: "2px solid #a36e29",
                color: "#a36e29",
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "0.8rem",
              }}
              onClick={() => setVariantDeleteDialogOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{
                width: "48%",
                fontWeight: "bold",
                background: "#a36e29",
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "0.8rem",
              }}
              onClick={() => {
                blockProduct(deleteRowId, true);
                setVariantDeleteDialogOpen(false);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {products === null || products.length === 0 ? (
        <></>
      ) : (
        <ThemeProvider theme={theme}>
          <SwipeableDrawer
            anchor="right"
            open={showDrawer}
            onClose={() => setShowDrawer(false)}
            PaperProps={{ style: { width: "60%" } }} // Adjust the width as needed
          >
            {products && products.length > 0 && productClicked !== null && (
              <div style={{ padding: "1vw", paddingLeft: "2vw" }}>
                {/* Image Gallery */}
                <div style={{ display: "flex", marginBottom: "20px" }}>
                  {products[productClicked].images &&
                    Array.isArray(products[productClicked].images) &&
                    products[productClicked].images.map((image, index) => (
                      <div key={index} style={{ marginRight: "10px" }}>
                        {image.type === "img" ? (
                          <img
                            src={`${process.env.REACT_APP_API_URL}assets/${image.file}`}
                            alt={`Product ${index + 1}`}
                            style={{ width: "300px" }}
                          />
                        ) : (
                          <video
                            controls
                            width="300"
                            style={{ objectFit: "cover" }}
                          >
                            <source
                              src={`${process.env.REACT_APP_API_URL}assets/${image.file}`}
                              type="video/mp4"
                            />
                          </video>
                        )}
                      </div>
                    ))}
                </div>
                {/* Product Details */}
                <div style={{ marginBottom: "20px" }}>
                  <h2
                    style={{
                      marginBottom: "10px",
                      fontFamily: "'Work Sans', sans-serif",
                    }}
                  >
                    {products[productClicked].name}
                  </h2>

                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      color: "#666",
                      fontSize: "0.9rem",
                      marginBottom: "15px",
                      fontFamily: "'Work Sans', sans-serif",
                    }}
                  >
                    <span>{products[productClicked].category}</span>
                    <span>•</span>
                    <span>{products[productClicked].sub_category}</span>
                  </div>

                  <div
                    style={{
                      color: "#444",
                      fontSize: "1rem",
                      lineHeight: "1.5",
                      marginBottom: "15px",
                      fontFamily: "'Work Sans', sans-serif",
                    }}
                  >
                    {products[productClicked].description ||
                      "No description available"}
                  </div>
                  <div
                    style={{
                      color: "#444",
                      fontSize: "1rem",
                      marginBottom: "15px",
                      fontFamily: "'Work Sans', sans-serif",
                    }}
                  >
                    <span style={{ color: "#666" }}>HSN Code: </span>
                    {products[productClicked].hsn || "Not available"}
                  </div>

                  {products[productClicked].customizations?.variants?.options[0]
                    ?.metal_info && (
                      <>
                        <div
                          style={{
                            marginTop: "20px",
                            borderRadius: "10px",
                            padding: "10px 20px",
                            fontFamily: '"Roboto", sans-serif',
                            border: "1px solid #e1e1e1",
                            boxShadow: "0px 0px 5px 0px #a36e29",
                            width: "fit-content",
                          }}
                        >
                          <h3
                            style={{
                              marginBottom: "10px",
                              color: "#333",
                              fontSize: "1.1rem",
                            }}
                          >
                            Metal Information
                          </h3>

                          {(() => {
                            try {
                              const metalInfo =
                                products[productClicked].customizations.variants
                                  .options[0].metal_info;
                              const keys = Object.keys(metalInfo);
                              return (
                                <table
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      {keys.map((key) => (
                                        <th
                                          key={key}
                                          style={{
                                            textAlign: "left",
                                            padding: "8px",
                                            borderBottom: "1px solid #ddd",
                                            color: "#666",
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {key.includes("quality")
                                            ? "Purity"
                                            : key.split("_").join(" ")}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      {keys.map((key) => {
                                        const value = metalInfo[key];
                                        return (
                                          <td
                                            key={key}
                                            style={{
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                            }}
                                          >
                                            {key.includes("amount") ||
                                              key.includes("charge")
                                              ? "₹ "
                                              : ""}
                                            {typeof value === "number"
                                              ? value.toFixed(2)
                                              : value}
                                            {key.includes("perc") ||
                                              key.includes("percentage")
                                              ? "%"
                                              : ""}
                                            {key.includes("wt") ? " g" : ""}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </tbody>
                                </table>
                              );
                            } catch (error) {
                              console.error(
                                "Error displaying metal_info:",
                                error
                              );
                              return (
                                <div>Unable to display metal information</div>
                              );
                            }
                          })()}
                        </div>
                        <div
                          style={{
                            marginTop: "20px",
                            borderRadius: "10px",
                            padding: "10px 20px",
                            fontFamily: '"Roboto", sans-serif',
                            border: "1px solid #e1e1e1",
                            boxShadow: "0px 0px 5px 0px #a36e29",
                            width: "71.6rem",
                          }}
                        >
                          <h3
                            style={{
                              marginBottom: "10px",
                              color: "#333",
                              fontSize: "1.1rem",
                            }}
                          >
                            Stone Information
                          </h3>

                          {(() => {
                            try {
                              const stoneInfo =
                                products[productClicked].customizations.variants
                                  .options[0].stone_info;
                              const keys = Object.keys(stoneInfo);
                              if (!keys.length) return null;

                              return (
                                <table
                                  style={{
                                    width: "100%",
                                    marginTop: "20px",
                                    borderCollapse: "collapse",
                                    backgroundColor: "#f9f9f9",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      {keys.map((key) => {
                                        const keyName = key;
                                        return (
                                          <th
                                            key={keyName}
                                            style={{
                                              textAlign: "left",
                                              padding: "8px",
                                              borderBottom: "1px solid #ddd",
                                              color: "#666",
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {keyName.split("_").join(" ")}
                                          </th>
                                        );
                                      })}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      {keys.map((key) => {
                                        console.log(stoneInfo);
                                        const value = stoneInfo[key];
                                        return (
                                          <td
                                            key={key}
                                            style={{
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                            }}
                                          >
                                            {key.includes("rate") ||
                                              key.includes("amount")
                                              ? "₹ "
                                              : ""}
                                            {typeof value === "number"
                                              ? value.toFixed(2)
                                              : value}
                                            {key.includes("perc") ||
                                              key.includes("percentage")
                                              ? "%"
                                              : ""}
                                            {key.includes("wt") ||
                                              key.includes("carat")
                                              ? " g"
                                              : ""}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </tbody>
                                </table>
                              );
                            } catch (error) {
                              console.error(
                                "Error displaying stone_info:",
                                error
                              );
                              return (
                                <div>Unable to display stone information</div>
                              );
                            }
                          })()}
                        </div>

                        {products[productClicked]?.product_variants.map((item) => (
                          <div 
                          style={{
                            marginTop: "20px",
                            borderRadius: "10px",
                            padding: "10px 20px",
                            fontFamily: '"Roboto", sans-serif',
                            border: "1px solid #e1e1e1",
                            boxShadow: "0px 0px 5px 0px #a36e29",
                            width: "fit-content",
                          }}>
                          <div
                            style={{
                              marginTop: "20px",
                              borderRadius: "10px",
                              padding: "10px 20px",
                              fontFamily: '"Roboto", sans-serif',
                              border: "1px solid #e1e1e1",
                              // boxShadow: "0px 0px 5px 0px #a36e29",
                              width: "fit-content",
                            }}
                          >
                            <h3
                              style={{
                                marginBottom: "10px",
                                color: "#333",
                                fontSize: "1.1rem",
                              }}
                            >
                              Variant {item.name}
                            </h3>

                            {(() => {
                              try {
                                const metalInfo =
                                  item.metal_info;
                                const keys = Object.keys(metalInfo);
                                return (
                                  <table
                                    style={{
                                      width: "100%",
                                      borderCollapse: "collapse",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        {keys.map((key) => (
                                          <th
                                            key={key}
                                            style={{
                                              textAlign: "left",
                                              padding: "8px",
                                              borderBottom: "1px solid #ddd",
                                              color: "#666",
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {key.includes("quality")
                                              ? "Purity"
                                              : key.split("_").join(" ")}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        {keys.map((key) => {
                                          const value = metalInfo[key];
                                          return (
                                            <td
                                              key={key}
                                              style={{
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                              }}
                                            >
                                              {key.includes("amount") ||
                                                key.includes("charge")
                                                ? "₹ "
                                                : ""}
                                              {typeof value === "number"
                                                ? value.toFixed(2)
                                                : value}
                                              {key.includes("perc") ||
                                                key.includes("percentage")
                                                ? "%"
                                                : ""}
                                              {key.includes("wt") ? " g" : ""}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    </tbody>
                                  </table>
                                );
                              } catch (error) {
                                console.error(
                                  "Error displaying metal_info:",
                                  error
                                );
                                return (
                                  <div>Unable to display metal information</div>
                                );
                              }
                            })()}
                          </div>
                            <div
                              style={{
                                marginTop: "20px",
                                borderRadius: "10px",
                                padding: "10px 20px",
                                fontFamily: '"Roboto", sans-serif',
                                border: "1px solid #e1e1e1",
                                // boxShadow: "0px 0px 5px 0px #a36e29",
                                width: "71.6rem",
                              }}
                            >
                              <h3
                                style={{
                                  marginBottom: "10px",
                                  color: "#333",
                                  fontSize: "1.1rem",
                                }}
                              >
                                Stone Information
                              </h3>

                              {(() => {
                                try {
                                  const stoneInfo =
                                    products[productClicked].customizations.variants
                                      .options[0].stone_info;
                                  const keys = Object.keys(stoneInfo);
                                  if (!keys.length) return null;

                                  return (
                                    <table
                                      style={{
                                        width: "100%",
                                        marginTop: "20px",
                                        borderCollapse: "collapse",
                                        backgroundColor: "#f9f9f9",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          {keys.map((key) => {
                                            const keyName = key;
                                            return (
                                              <th
                                                key={keyName}
                                                style={{
                                                  textAlign: "left",
                                                  padding: "8px",
                                                  borderBottom: "1px solid #ddd",
                                                  color: "#666",
                                                  textTransform: "capitalize",
                                                }}
                                              >
                                                {keyName.split("_").join(" ")}
                                              </th>
                                            );
                                          })}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          {keys.map((key) => {
                                            console.log(stoneInfo);
                                            const value = stoneInfo[key];
                                            return (
                                              <td
                                                key={key}
                                                style={{
                                                  padding: "8px",
                                                  borderBottom: "1px solid #eee",
                                                }}
                                              >
                                                {key.includes("rate") ||
                                                  key.includes("amount")
                                                  ? "₹ "
                                                  : ""}
                                                {typeof value === "number"
                                                  ? value.toFixed(2)
                                                  : value}
                                                {key.includes("perc") ||
                                                  key.includes("percentage")
                                                  ? "%"
                                                  : ""}
                                                {key.includes("wt") ||
                                                  key.includes("carat")
                                                  ? " g"
                                                  : ""}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      </tbody>
                                    </table>
                                  );
                                } catch (error) {
                                  console.error(
                                    "Error displaying stone_info:",
                                    error
                                  );
                                  return (
                                    <div>Unable to display stone information</div>
                                  );
                                }
                              })()}
                            </div>
                          </div>

                        ))}
                      </>
                    )}
                </div>
              </div>
            )}
          </SwipeableDrawer>
        </ThemeProvider>
      )}
      <div className="head">
        <div className="head-txt">Products</div>
        <TextField
          className="search"
          variant="outlined"
          placeholder="Search Products..."
          onChange={(e) => search(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    search("");
                    document.getElementById("searchField").value = "";
                  }}
                >
                  <Clear />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            marginRight: "16px",
            width: "300px",
          }}
        />
      </div>

      <Divider />
      <ThemeProvider theme={theme}>
        <Paper className="table-paper">
          {products === null ? (
            <CircularProgress
              style={{
                margin: "auto",
                display: "flex",
                height: "100%",
              }}
            />
          ) : (
            <>
              <TableContainer style={{ maxHeight: "95%" }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Index</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Company</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Tag</TableCell>
                      <TableCell>UID</TableCell>
                      <TableCell>Gross Weight</TableCell>
                      <TableCell>Admin Verified</TableCell>
                      <TableCell>View in Store</TableCell>
                      <TableCell>Actions</TableCell>
                      <TableCell>Variants</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {searchResults
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <>
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row?.id}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <TableCell>
                                {row.display_number + ( + 1)}
                              </TableCell>
                              <TableCell
                                className="name-content"
                                onClick={() => rowClicked(row)}
                              >
                                <div className="name-content-inner">
                                  {row?.images ? (
                                    <img
                                      className="company-img"
                                      alt="product"
                                      src={`${process.env.REACT_APP_API_URL}assets/${row?.images[0]?.file}`}
                                    />
                                  ) : (
                                    <img
                                      className="company-img"
                                      alt="product"
                                      src={``}
                                    />
                                  )}
                                  {row?.name}
                                </div>
                              </TableCell>
                              <TableCell className="name-content">
                                <div className="name-content-inner">
                                  <img
                                    className="company-img"
                                    alt="product"
                                    src={`${process.env.REACT_APP_API_URL}assets/${row?.company?.logo}`}
                                  />

                                  {row.company.name}
                                </div>
                              </TableCell>
                              <TableCell>
                                ₹{row.customizations.variants.options[0]?.price}
                              </TableCell>
                              <TableCell>{row.tags}</TableCell>
                              <TableCell>
                                <strong>{row.hash}</strong>
                              </TableCell>
                              <TableCell>
                                {`${row.customizations.variants.options[0].metal_info.gross_wt} gm`}
                              </TableCell>
                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "5px 15px",
                                    backgroundColor:
                                      row.admin_verified === "1"
                                        ? "#cffbcf"
                                        : "#ffcfcf",
                                    borderRadius: "5px",
                                    color:
                                      row.admin_verified === "1"
                                        ? "#008000"
                                        : "#ff0000",
                                    height: "24px",
                                    width: "fit-content",
                                  }}
                                >
                                  {row.admin_verified === "1" ? "Yes" : "No"}
                                </div>
                              </TableCell>
                              <TableCell>
                                <a
                                  href={`https://sadashrijewelkart.com/item/${row.category}/${row.name}-${row.hash}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#a36e29",
                                    textDecoration: "none",
                                  }}
                                >
                                  View
                                </a>
                              </TableCell>
                              <TableCell className="actions-content">
                                {row.admin_verified === "0" ? (
                                  <div>
                                    {
                                      <Done
                                        className="allow"
                                        onClick={() => allowProduct(row.id, row)}
                                      />
                                    }
                                    <Close
                                      className="block"
                                      onClick={() => {
                                        setDeleteRowId(row.id);
                                        setDeleteDialogOpen(true);
                                        // blockProduct(row.id)
                                      }}
                                    />
                                  </div>
                                ) : row.admin_verified === "1" ? (
                                  <Close
                                    className="block"
                                    onClick={() => {
                                      setDeleteRowId(row.id);
                                      setDeleteDialogOpen(true);
                                      // blockProduct(row.id)
                                    }}
                                  />
                                ) : row.admin_verified === "2" ? (
                                  <div className="rejected">Blocked</div>
                                ) : (
                                  <div>
                                    {checkProductInfographics(row) && (
                                      <Done
                                        className="allow"
                                        onClick={() => allowProduct(row.id)}
                                      />
                                    )}
                                    <Close
                                      className="block"
                                      onClick={() => {
                                        setDeleteRowId(row.id);
                                        setDeleteDialogOpen(true);
                                        // blockProduct(row.id)
                                      }}
                                    />
                                  </div>
                                )}
                              </TableCell>
                              <TableCell>
                                <IconButton onClick={() => setOpenVariant((prev) => prev === row.id ? null : row.id)}>
                                  {openVariant === row.id ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                              </TableCell>
                            </TableRow>
                            {openVariant === row.id && row.product_variants.map((variant, variantIndex) => (
                              <>
                                {row.product_variants.length > 0 && variantIndex === 0 && (<h2 style={{paddingLeft: "2rem"}}>Variants</h2>)}
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={variant.id}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <TableCell style={{ paddingLeft: "2rem" }}>
                                    {variantIndex + 1}
                                  </TableCell>
                                  <TableCell>{variant.name}</TableCell>
                                  <TableCell>{row.company.name}</TableCell>
                                  <TableCell>₹{variant.price}</TableCell>
                                  <TableCell>{variant.tag}</TableCell>
                                  <TableCell>
                                    <strong>{variant?.master_product_details?.hash}</strong>
                                  </TableCell>
                                  <TableCell>
                                    {`${variant?.metal_info?.gross_wt ?? 0} gm`}
                                  </TableCell>
                                  <TableCell>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        padding: "5px 15px",
                                        backgroundColor:
                                          variant.admin_verified === "1"
                                            ? "#cffbcf"
                                            : "#ffcfcf",
                                        borderRadius: "5px",
                                        color:
                                          variant.admin_verified === "1"
                                            ? "#008000"
                                            : "#ff0000",
                                        height: "24px",
                                        width: "fit-content",
                                      }}
                                    >
                                      {variant.admin_verified === "1" ? "Yes" : "No"}
                                    </div>
                                  </TableCell>
                                  <TableCell>
                                    <a
                                      href={`https://sadashrijewelkart.com/item/${variant?.master_product_details?.category}/${variant?.master_product_details?.name}-${variant?.master_product_details?.hash}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "#a36e29",
                                        textDecoration: "none",
                                      }}
                                    >
                                      View
                                    </a>
                                  </TableCell>
                                  { row.admin_verified === "1" && variant.admin_verified === "0" && <TableCell className="actions-content">
                                    {variant.admin_verified === "0" ? (
                                      <div>
                                        {
                                          <Done
                                            className="allow"
                                            onClick={() => allowProductVariant(variant.id, variant)}
                                          />
                                        }
                                        <Close
                                          className="block"
                                          onClick={() => {
                                            // setDeleteRowId(row.id);
                                            setDeleteDialogOpen(true);
                                            blockProduct(variant.id);
                                          }}
                                        />
                                      </div>
                                    ) : variant.admin_verified === "1" ? (
                                      <Close
                                        className="block"
                                        onClick={() => {
                                          setDeleteRowId(variant.id);
                                          setVariantDeleteDialogOpen(true);
                                          // blockProduct(variant.id);
                                        }}
                                      />
                                    ) : variant.admin_verified === "2" ? (
                                      <div className="rejected">Blocked</div>
                                    ) : (
                                      <div>
                                        {checkProductInfographics(row) && (
                                          <Done
                                            className="allow"
                                            onClick={() => allowProductVariant(variant.id, variant)}
                                          />
                                        )}
                                        <Close
                                          className="block"
                                          onClick={() => {
                                            setDeleteRowId(variant.id);
                                            setVariantDeleteDialogOpen(true);
                                            // blockProduct(variant.id, true);
                                          }}
                                        />
                                      </div>
                                    )}
                                  </TableCell>
                                  }
                                </TableRow>
                              </>
                            ))}
                          </>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[25, 50, 100, 200]}
                component="div"
                count={products.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          )}
        </Paper>
      </ThemeProvider>
      {/* Dialog to add a response for rejecting the product */}
      <Dialog
        open={dialog || variantDialog}
        onClose={() => {
          setDialog(false);
          setVariantDialog(false);
        }}
        disableEscapeKeyDown
        sx={{
          "& .MuiDialogTitle-root": {
            fontSize: "1.5rem",
            fontWeight: 600,
            marginBottom: "10px",
          },
          "& .MuiDialogContent-root": {
            fontSize: "1.2rem",
            fontWeight: 400,
            marginBottom: "10px",
          },
        }}
      >
        <ThemeProvider theme={theme}>
          <DialogTitle>Add Rejection Message</DialogTitle>
          <Divider />
          <DialogContent
            sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            Please Enter the rejection message for rejecting the product.
            <br />
            <TextareaAutosize
              className="field"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              minRows={3}
              placeholder={`Enter message here`}
              style={{
                padding: "5px",
                marginBottom: "10px",
                marginTop: "10px",
                fontSize: "16px",
              }}
            />
          </DialogContent>
          <DialogActions sx={{ marginBottom: "10px", marginRight: "10px" }}>
            <Button onClick={() => {
              setDialog(false);
              setVariantDialog(false);
            }}>Close</Button>
            <Button
              variant="contained"
              onClick={handleBlockProductDialog}
              className="closeButton"
            >
              Send
            </Button>
          </DialogActions>
        </ThemeProvider>
      </Dialog>
    </div>
  );
};

export default ProductComponent;
